'use strict';

import { Pricelist } from './Pricelist';
import { Configuration } from './Configuration';
import { InvalidConfigurationError } from './InvalidConfigurationError';

class Door {

    constructor(partition) {
        /**
         * @type {Partition}
         * @private
         */
        this._partition = partition;

        /**
         * @type {string}
         * @private
         */
        this._type = this.noDoor;

        /**
         * @type {string}
         * @private
         */
        this._ironmongery = this.ironmongeryDHandle;

        /**
         * @type {object}
         */
        this._configuration = Configuration.get();

        /**
         * @type {object}
         */
        this._pricelist = Pricelist.get();
    }

    /**
     * @param {string} doorType
     */
    set type(doorType) {

        if (this._partition.hasValidDimensions === false) {
            throw new InvalidConfigurationError('Dimensions are invalid');
        }

        if (this._partition.glassThickness === undefined) {
            throw new InvalidConfigurationError('Glass thickness undefined');
        }

        if (this._checkDoorType(doorType) === false) {
            throw new InvalidConfigurationError();
        }

        this._type = doorType;
    }

    /**
     * @returns {number}
     */
    get totalInPence() {
        // If the door is configured incorrectly return 0
        if (this._checkDoorType(this._type) === false) {
            return 0;
        }

        let doorPrice = this._pricelist.doors[this._type];
        let ironmongeryPrice = this._pricelist.ironmongery[this._ironmongery];

        // No door means no handle
        if (this._type === this.noDoor) {
            ironmongeryPrice = 0;
        }

        let pricePerDoor = doorPrice + ironmongeryPrice;
        let totalPrice = pricePerDoor;

        if (this._partition.type === this._partition.tShapeType) {
            totalPrice = pricePerDoor * 2;
        }

        return totalPrice;
    }

    /**
     * @param {string} ironmongery
     */
    set ironmongery(ironmongery) {
        this._ironmongery = ironmongery;
    }

    /**
     * @returns {string}
     */
    get noDoor() {
        return 'noDoor';
    }

    /**
     * @returns {string}
     */
    get singleGlazedDoorFrameless() {
        return 'singleGlazedDoorFrameless';
    }

    /**
     * @returns {string}
     */
    get singleGlazedDoorIncFrame() {
        return 'singleGlazedDoorIncFrame';
    }

    /**
     * @returns {string}
     */
    get singleGlazedDoorIncSingleGlazedFrame() {
        return 'singleGlazedDoorIncSingleGlazedFrame';
    }

    /**
     * @returns {string}
     */
    get singleGlazedDoorIncDoubleGlazedFrame() {
        return 'singleGlazedDoorIncDoubleGlazedFrame';
    }

    /**
     * @returns {string}
     */
    get doubleGlazedDoor() {
        return 'doubleGlazedDoor';
    }

    /**
     * @returns {string}
     */
    get ironmongeryDHandle() {
        return 'dHandle';
    }

    /**
     * @returns {string}
     */
    get ironmongeryManet() {
        return 'manet';
    }

    /**
     * @returns {string}
     */
    get ironmongeryLeverLock() {
        return 'leverLock';
    }

    /**
     * @param {string} doorType
     * @returns {boolean}
     * @private
     */
    _checkDoorType(doorType) {
        let configuration = this._configuration.singleGlazed.doors;

        if (doorType === this.noDoor && this._partition.numberOfSides === 4) {
            return false;
        }

        if (this._partition.isDoubleGlazed) {
            configuration = this._configuration.doubleGlazed.doors;
        }

        return Boolean(configuration.includes(doorType));
    }
}

export { Door };



// WEBPACK FOOTER //
// ./src/objects/Door.js